import { useMutation } from '@tanstack/react-query';

import { BalanceSheetApi } from '../balanceSheet.api';

export const useGetPpeAssetsCalculations = () => {
  return useMutation({
    mutationFn: BalanceSheetApi.getPpeAssetsCalculations,
  });
};
